"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgMap = void 0;

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSimpleMaps = require("react-simple-maps");

var _HoverShape = _interopRequireDefault(require("./HoverShape"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
  root: {},
  hover: {
    stroke: "#f00",
    fill: "transparent"
  }
};
/**
 * Base SVG Map
 */

var SvgMap = function SvgMap(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "classes", "children"]);

  return /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.ComposableMap, _extends({
    className: (0, _clsx["default"])("svg-map", classes.root, className),
    projection: "geoAlbersUsa"
  }, props), children);
};

exports.SvgMap = SvgMap;
SvgMap.propTypes = {
  className: _propTypes["default"].string
};
/** add the display name */

var exportComponent = (0, _styles.withStyles)(styles, {
  name: "HypSvgMap"
})(SvgMap);
exportComponent.displayName = "SvgMap";
var _default = exportComponent;
exports["default"] = _default;